// extracted by mini-css-extract-plugin
module.exports = {"input":"kOgpIjG"};